// The text field: label above, the control, helper or error text below.
// multiline renders a textarea in the same shell. For free text and
// numbers. Not for choices (Select), dates (DateField), or files
// (FilePicker).

import { FieldShell } from '../FieldShell/index.jsx'
import './input.css'

export function Input({ id, label, help, error, multiline = false, className = '', ...rest }) {
  const Control = multiline ? 'textarea' : 'input'
  return (
    <FieldShell id={id} label={label} help={help} error={error} className={className} always>
      <Control
        id={id}
        className={`ui-input${multiline ? ' ui-input-multiline' : ''}`}
        aria-invalid={error ? true : rest['aria-invalid']}
        {...rest}
      />
    </FieldShell>
  )
}
